import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import recommendOfficeAPI from '../../sources/api/recommendOfficeAPI';

// constants
import { SEND_RECOMMEND_OFFICE_EMAIL } from '../../constants/recommendOfficeType';

// lib
import httpSaga from '../../lib/httpSaga';
import { toastr } from 'react-redux-toastr';
import { RECOMMEND_OFFICE_SUCCESS, RECOMMEND_OFFICE_ERROR } from '../../constants/messages';

export function* sendRecommendOfficeEmail(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params = action.payload;

  try {
    yield *httpSaga(SEND_RECOMMEND_OFFICE_EMAIL, call(recommendOfficeAPI.sendRecommendOfficeEmail, params));
    yield toastr.success('Success', RECOMMEND_OFFICE_SUCCESS);
  } catch (e) {
    yield toastr.error(RECOMMEND_OFFICE_ERROR);
    yield put(error(SEND_RECOMMEND_OFFICE_EMAIL, e));
  } finally {
    yield put(doneIndicator(SEND_RECOMMEND_OFFICE_EMAIL));
  }
}

export function* watchSendRecommendOfficeEmail() {
  yield takeEvery(SEND_RECOMMEND_OFFICE_EMAIL, sendRecommendOfficeEmail);
}

export default function* root() {
  yield all([
    fork(watchSendRecommendOfficeEmail)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/recommendOffice/sendRecommendOfficeEmail.js